// ChatInterface.jsx
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getAdminChatUsers, markMessagesAsRead } from '../../services/chat.services';
import ChatWindow from './ChatWindow';
import { TrimText } from '../../../../utils/commonfunction';

const ChatInterface = () => {
    const [allUsers, setAllUsers] = useState([]);
    const [activeChat, setActiveChat] = useState({
        roomID: null,
        receiverDetails: null,
        bookingDetails: null, // Add other necessary details here
    });

    useEffect(() => {
        markMessagesAsRead().catch(console.error);

        getAdminChatUsers().then((res) => {
            if (res?.data) {
                setAllUsers(res.data);
                // Optional: Automatically select the first user
                if (res.data.length > 0) {
                    const firstUser = res.data[0];
                    setActiveChat({
                        roomID: firstUser.roomID,
                        receiverDetails: firstUser.users,
                    });
                }
            }
        }).catch((err) => {
            console.error("Error fetching chat users:", err);
        });
    }, []);

    const handleUserSelect = (user) => {
        setActiveChat({
            roomID: user.roomID,
            receiverDetails: user.users,
        });
        markMessagesAsRead({ roomID: user.roomID }).catch(console.error);
        setAllUsers((prev) =>
            prev.map((u) => (u.roomID === user.roomID ? { ...u, unreadCount: 0 } : u))
        );
    };
    console.log("Active Chat:", activeChat);

    return (
        <div className="container-fluid h-100">
            <div className="row h-100">
                {/*
                  1. CONTACTS LIST (Sidebar)
                */}
                <div className="col-12 col-md-4 border-end d-flex flex-column p-0" style={{ height: "80vh" }}>
                    <div className="p-3 bg-light border-bottom">
                        <h5 className="mb-0">Chats 💬</h5>
                    </div>

                    {/* List Container - Scrollable */}
                    <div className="list-group list-group-flush flex-grow-1 overflow-auto">
                        {/* {allUsers?.map((user) => (
                            <a 
                                href="#" 
                                key={user.roomID} 
                                className={`list-group-item list-group-item-action py-3 ${activeChat.roomID === user.roomID ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleUserSelect(user);
                                }}
                            >
                                <div className="d-flex w-100 justify-content-between align-items-center">
                                    <h6 className="mb-1">{user?.users?.name || 'Loading...'}</h6>
                                    <small className="text-muted">
                                        {user?.lastMessageTime ? moment(user.lastMessageTime).format('hh:mm A') : ''}
                                    </small> 
                                </div>
                                <p className="mb-1 small text-truncate">
                                    {user?.lastMessage || (user?.roomID ? 'Tap to start chat' : 'No messages')}
                                </p>
                            </a>
                        ))} */}
                        {allUsers?.map((user) => {
                            const profileImg = user?.users?.profile_image || "https://via.placeholder.com/40"; // fallback

                            return (
                                <a
                                    href="#"
                                    key={user.roomID}
                                    className={`list-group-item list-group-item-action py-3 border-0 ${activeChat.roomID === user.roomID ? "active" : ""}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleUserSelect(user);
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        {/* Profile Picture */}
                                        <div className="me-3">
                                            <img
                                                src={profileImg}
                                                alt={user?.users?.name || "User"}
                                                className="rounded-circle"
                                                style={{
                                                    width: "48px",
                                                    height: "48px",
                                                    objectFit: "cover",
                                                    border: "2px solid #e9ecef",
                                                }}
                                                onError={(e) => {
                                                    e.target.src = "https://via.placeholder.com/48?text=U"; // fallback on error
                                                }}
                                            />
                                        </div>

                                        {/* Name, Last Message, Time */}
                                        <div className="flex-grow-1 min-width-0">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <h6 className="mb-0 text-truncate" style={{ maxWidth: "180px" }}>
                                                    {user?.users?.name || "Unknown User"}
                                                    {user?.unreadCount > 0 && activeChat.roomID !== user.roomID && (
                                                        <span className="badge bg-danger ms-2" style={{ fontSize: "0.7rem" }}>
                                                            {user.unreadCount}
                                                        </span>
                                                    )}
                                                </h6>
                                                <small className="text-muted flex-shrink-0 ms-2">{user?.messageTimestamp ? moment(user.messageTimestamp).format("hh:mm A") : ""}</small>
                                            </div>
                                            <p className="mb-0 small text-muted text-truncate">{TrimText(user?.latestMessage, 40) || "No messages yet • Tap to start chat"}</p>
                                        </div>
                                    </div>
                                </a>
                            );
                        })}
                    </div>
                </div>

                {/*
                  2. CHAT WINDOW (Main Area)
                  - Renders the ChatWindow component for the active chat
                */}
                <div className="col-12 col-md-8 d-flex flex-column p-0" style={{ height: "80vh" }}>
                    <ChatWindow activeChat={activeChat} />
                </div>
            </div>
        </div>
    );
};

export default ChatInterface;